import IconComponent from "icons/IconComponent";

import SignOutAltIcon from "./sign-out-alt.svg";

export default (SignOutAltIcon as any) as IconComponent;
